var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { rechartsDiagonalStripeFillUrl, rechartsDiagonalStripePatternDefs } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { renderStackedBarCells } from '@web/components/layout/RechartsItems/StackedBarCells';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { WorkLocationBreakdownTooltip } from '@web/components/layout/WidgetTooltips/WorkLocationBreakdownTooltip';
import { TablesDiffColorsConfig, WORK_LOCATION_BREAKDOWN_CONFIG } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { applyMinBarHeight, calculateMinBarHeight, formatChartDayPeriodAxisLabel, getPeriodBarChartLayoutProps, isBarChartRowsEmpty } from '@web/utility/charts';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { formatDuration, getInterval } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var WORK_LOCATION_SERIES_KEYS = ['office', 'remote'];
var workLocationTeamStripePatternId = function (dataKey) {
    return "".concat(InsightTypeEnum.workLocationBreakdown, "_").concat(dataKey);
};
var WORK_LOCATION_TEAM_STRIPE_PATTERN_ENTRIES = [
    {
        patternId: workLocationTeamStripePatternId('teamOffice'),
        chartColor: WORK_LOCATION_BREAKDOWN_CONFIG.office.teamAverageColor
    },
    {
        patternId: workLocationTeamStripePatternId('teamRemote'),
        chartColor: WORK_LOCATION_BREAKDOWN_CONFIG.remote.teamAverageColor
    }
];
export var WorkLocationBreakdown = function (_a) {
    var _b, _c;
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var _d = trpc.workLocationBreakdown.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), data = _d.data, isLoading = _d.isLoading, refetch = _d.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var interval = getInterval(dateFrom, dateTo);
    var showTeam = Boolean(userId);
    var maxValue = 0;
    var chartData = data.periods.map(function (period) {
        var _a, _b;
        var values = [
            period.previousOfficeHours,
            period.previousRemoteHours,
            period.officeHours,
            period.remoteHours
        ];
        if (showTeam && period.teamAverageOfficeHours !== null) {
            values.push(period.teamAverageOfficeHours, (_a = period.teamAverageRemoteHours) !== null && _a !== void 0 ? _a : 0);
        }
        maxValue = Math.max.apply(Math, __spreadArray([maxValue], values, false));
        var entry = {
            period: period.period,
            previousOffice: period.previousOfficeHours,
            previousRemote: period.previousRemoteHours,
            currentOffice: period.officeHours,
            currentRemote: period.remoteHours
        };
        if (showTeam && period.teamAverageOfficeHours !== null) {
            entry.teamOffice = period.teamAverageOfficeHours;
            entry.teamRemote = (_b = period.teamAverageRemoteHours) !== null && _b !== void 0 ? _b : 0;
        }
        return entry;
    });
    var minBarHeight = calculateMinBarHeight(maxValue);
    chartData.forEach(function (entry) {
        entry.previousOffice = applyMinBarHeight(entry.previousOffice, minBarHeight);
        entry.previousRemote = applyMinBarHeight(entry.previousRemote, minBarHeight);
        entry.currentOffice = applyMinBarHeight(entry.currentOffice, minBarHeight);
        entry.currentRemote = applyMinBarHeight(entry.currentRemote, minBarHeight);
        if (entry.teamOffice !== undefined) {
            entry.teamOffice = applyMinBarHeight(entry.teamOffice, minBarHeight);
        }
        if (entry.teamRemote !== undefined) {
            entry.teamRemote = applyMinBarHeight(entry.teamRemote, minBarHeight);
        }
    });
    var _e = getPeriodBarChartLayoutProps({
        barGroupCount: chartData.length,
        barsPerGroup: showTeam ? 3 : 2
    }), barGap = _e.barGap, barSize = _e.barSize, periodXAxis = _e.periodXAxis, periodBarChartMargin = _e.periodBarChartMargin;
    var chartPlotEmpty = isBarChartRowsEmpty(chartData);
    var totals = data.totals;
    var legendItems = [
        {
            key: 'office',
            color: WORK_LOCATION_BREAKDOWN_CONFIG.office.color,
            chartColor: WORK_LOCATION_BREAKDOWN_CONFIG.office.currentPeriodColor,
            label: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.officeWork'),
            value: totals.officeHours,
            diff: totals.officeHoursPrevPeriodDiff,
            teamAverage: showTeam
                ? ((_b = totals.officeHoursTeamAvgDiff) !== null && _b !== void 0 ? _b : undefined)
                : undefined,
            stripeChartColor: showTeam
                ? WORK_LOCATION_BREAKDOWN_CONFIG.office.teamAverageColor
                : undefined
        },
        {
            key: 'remote',
            color: WORK_LOCATION_BREAKDOWN_CONFIG.remote.color,
            chartColor: WORK_LOCATION_BREAKDOWN_CONFIG.remote.currentPeriodColor,
            label: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.remoteWork'),
            value: totals.remoteHours,
            diff: totals.remoteHoursPrevPeriodDiff,
            teamAverage: showTeam
                ? ((_c = totals.remoteHoursTeamAvgDiff) !== null && _c !== void 0 ? _c : undefined)
                : undefined,
            stripeChartColor: showTeam
                ? WORK_LOCATION_BREAKDOWN_CONFIG.remote.teamAverageColor
                : undefined
        }
    ];
    var renderWorkLocationTooltip = createEdgePositionedBarTooltipContent(function (_a) {
        var active = _a.active, label = _a.label;
        var periodData = data.periods.find(function (p) { return p.period === label; });
        return (_jsx(WorkLocationBreakdownTooltip, { active: active, label: label, t: t, showTeam: showTeam, periodData: periodData, dateFrom: dateFrom, dateTo: dateTo }));
    }, chartData.length);
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: userId
                    ? t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.userWorkLocationBreakdown')
                    : t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.workLocationBreakdown'), description: userId
                    ? t('widgetTitleDescriptions.scheduleAndAttendance.userWorkLocationBreakdown')
                    : t('widgetTitleDescriptions.scheduleAndAttendance.workLocationBreakdown'), insightType: InsightTypeEnum.workLocationBreakdown, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t(userId
                        ? 'app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.userWorkLocationBreakdown'
                        : 'app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.workLocationBreakdown'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            return [2 /*return*/, ((_a = data.periods) !== null && _a !== void 0 ? _a : []).map(function (period) {
                                    var _a;
                                    var officeLabel = t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.officeWork');
                                    var remoteLabel = t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.remoteWork');
                                    var teamAvgLabel = t('export.teamAverage');
                                    var row = (_a = {},
                                        _a[t('filters.period')] = period.period,
                                        _a[officeLabel] = formatDuration(period.officeHours, 'hours'),
                                        _a[remoteLabel] = formatDuration(period.remoteHours, 'hours'),
                                        _a);
                                    if (userId) {
                                        row["".concat(teamAvgLabel, " - ").concat(officeLabel)] =
                                            period.teamAverageOfficeHours != null
                                                ? formatDuration(period.teamAverageOfficeHours, 'hours')
                                                : '';
                                        row["".concat(teamAvgLabel, " - ").concat(remoteLabel)] =
                                            period.teamAverageRemoteHours != null
                                                ? formatDuration(period.teamAverageRemoteHours, 'hours')
                                                : '';
                                    }
                                    return row;
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: WORK_LOCATION_SERIES_KEYS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, __assign({ cardClassName: "shadow overflow-x-auto lg:overflow-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: [_jsx("div", __assign({ className: "mb-6 ml-2 flex flex-wrap justify-start gap-4 rounded-lg p-4 sm:gap-8 lg:gap-8" }, { children: legendItems.map(function (item) { return (_jsx(LegendItem, { color: item.color, label: item.label, currentValue: formatDuration(item.value, 'hours'), diffValue: item.diff, teamAverage: item.teamAverage, stripeChartColor: item.stripeChartColor, arrowColor: TablesDiffColorsConfig.GREEN, onClick: function () { return toggleSeries(item.key); }, isHidden: !isSeriesVisible(item.key) }, item.key)); }) })), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: chartData, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [showTeam &&
                                                rechartsDiagonalStripePatternDefs(WORK_LOCATION_TEAM_STRIPE_PATTERN_ENTRIES), _jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "period", axisLine: false, tickLine: false }, periodXAxis, { tickFormatter: function (value) {
                                                    return formatChartDayPeriodAxisLabel(value, interval, {
                                                        dateFrom: dateFrom,
                                                        dateTo: dateTo
                                                    });
                                                } })), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, tickFormatter: function (value) { return "".concat(value, "h"); } }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderWorkLocationTooltip }), _jsx(Bar, __assign({ dataKey: "previousOffice", fill: WORK_LOCATION_BREAKDOWN_CONFIG.office.previousPeriodColor, stackId: "previous", hide: !isSeriesVisible('office') }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: ['previousOffice', 'previousRemote'],
                                                    segmentIndex: 0,
                                                    keyPrefix: 'prev-office'
                                                }) })), _jsx(Bar, __assign({ dataKey: "previousRemote", fill: WORK_LOCATION_BREAKDOWN_CONFIG.remote.previousPeriodColor, stackId: "previous", hide: !isSeriesVisible('remote') }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: ['previousOffice', 'previousRemote'],
                                                    segmentIndex: 1,
                                                    keyPrefix: 'prev-remote'
                                                }) })), _jsx(Bar, __assign({ dataKey: "currentOffice", fill: WORK_LOCATION_BREAKDOWN_CONFIG.office.currentPeriodColor, stackId: "current", hide: !isSeriesVisible('office') }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: ['currentOffice', 'currentRemote'],
                                                    segmentIndex: 0,
                                                    keyPrefix: 'curr-office'
                                                }) })), _jsx(Bar, __assign({ dataKey: "currentRemote", fill: WORK_LOCATION_BREAKDOWN_CONFIG.remote.currentPeriodColor, stackId: "current", hide: !isSeriesVisible('remote') }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: ['currentOffice', 'currentRemote'],
                                                    segmentIndex: 1,
                                                    keyPrefix: 'curr-remote'
                                                }) })), showTeam && (_jsxs(_Fragment, { children: [_jsx(Bar, __assign({ dataKey: "teamOffice", fill: rechartsDiagonalStripeFillUrl(workLocationTeamStripePatternId('teamOffice')), stackId: "team", hide: !isSeriesVisible('office') }, { children: renderStackedBarCells({
                                                            chartData: chartData,
                                                            stackDataKeys: ['teamOffice', 'teamRemote'],
                                                            segmentIndex: 0,
                                                            keyPrefix: 'team-office'
                                                        }) })), _jsx(Bar, __assign({ dataKey: "teamRemote", fill: rechartsDiagonalStripeFillUrl(workLocationTeamStripePatternId('teamRemote')), stackId: "team", hide: !isSeriesVisible('remote') }, { children: renderStackedBarCells({
                                                            chartData: chartData,
                                                            stackDataKeys: ['teamOffice', 'teamRemote'],
                                                            segmentIndex: 1,
                                                            keyPrefix: 'team-remote'
                                                        }) }))] }))] })) })) }))] })));
                } }))] })));
};
